'use strict';

exports.__esModule = true;

var _highlight = require('highlight.js');

var _highlight2 = _interopRequireDefault(_highlight);

require('highlight.js/styles/vs.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*=====================================
    程式碼 highlight 匯入的套件

    Author: Gray
    CreateTime: 2020 / 07 / 17
=====================================*/

exports.default = _highlight2.default; // 核心套件

module.exports = exports['default'];